import React from 'react';
import { Prompt } from 'react-router-dom';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Button from '../../../../components/atomic/Buttons/Button';
import TextInput from '../../../../components/molecule/FormFields/TextInput';

const Container = styled.div`
  display: flex;
  justify-content: center;
`
const StretchContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  // background: rgba(0,0,0,0.1);
  margin: 3px;
  margin-bottom: auto;
`
const TextInputStyled = styled(TextInput)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`
const ButtonStyled = styled(Button)`
  margin-left: 8px;
`
const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
`

class WebsiteForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  render () {
    const {
      values,
      onClickCancel,
      dirty,
    } = this.props
    return (
      <FormStyled>
        <Container>
          <StretchContainer>
            <InfoContainer>
              <TextInputStyled
                type="text"
                onChange={(val) => this.changeTracker(val, 'website')}
                value={values.website}
              />
            </InfoContainer>
          </StretchContainer>
        </Container>
        <ButtonContainer>
          <ButtonStyled disabled={!dirty} type="submit" color="primary" variant="contained">Save</ButtonStyled>
          <ButtonStyled onClick={onClickCancel} color="secondary" variant="contained">Cancel</ButtonStyled>
        </ButtonContainer>
        <Prompt when={dirty} message={`You have unsaved changes. Are you sure you want to leave?`}/>
      </FormStyled>
    );
  }
};

export default withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    website: yup.string(),
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'BasicForm',
})(WebsiteForm);
